
import React from "react";
import { Clock, Timer } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface RotationTimeControlProps {
  rotationTime: number;
  useCustomRotationTime: boolean;
  globalRotationTime: number;
  onRotationTimeChange: (value: number[]) => void;
  onRotationTimeInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUseCustomRotationTimeChange: (checked: boolean) => void;
}

export const RotationTimeControl: React.FC<RotationTimeControlProps> = ({ 
  rotationTime, 
  useCustomRotationTime,
  globalRotationTime,
  onRotationTimeChange, 
  onRotationTimeInputChange,
  onUseCustomRotationTimeChange
}) => {
  return (
    <div className="w-full space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Clock className="h-4 w-4 ml-2" />
          <Label>זמן תצוגה</Label>
        </div>
        
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center space-x-2">
                <Label htmlFor="use-custom-rotation-time" className="text-sm cursor-pointer">
                  זמן תצוגה מותאם אישית
                </Label>
                <Switch 
                  id="use-custom-rotation-time" 
                  checked={useCustomRotationTime} 
                  onCheckedChange={onUseCustomRotationTimeChange}
                />
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>הגדר זמן תצוגה ספציפי לדף זה שיעקוף את הגדרת ברירת המחדל ({globalRotationTime} שניות)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      
      {useCustomRotationTime ? (
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <Slider 
              value={[rotationTime]} 
              min={3}
              max={60}
              step={1}
              onValueChange={onRotationTimeChange}
            />
          </div>
          <div className="w-20">
            <div className="flex items-center">
              <Input 
                type="number" 
                min={3}
                value={rotationTime}
                onChange={onRotationTimeInputChange}
                className="w-16 text-center"
              />
              <span className="mr-1">שניות</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-sm text-muted-foreground flex items-center">
          <Timer className="h-4 w-4 mr-2" />
          משתמש בזמן תצוגה גלובלי ({globalRotationTime} שניות)
        </div>
      )}
    </div>
  );
};
